  

  // D-day 계산 함수
  export const calcDday = (targetDate:Date) => {
    if (!targetDate) return -1;
    const today = new Date();
    const end = targetDate;
    const diff = Math.ceil((end.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
    return diff;
  };


  export function stringToDate(_date:string,_format:string,_delimiter:string)
  {
    const formatLowerCase=_format.toLowerCase();
    const formatItems=formatLowerCase.split(_delimiter);
    const dateItems=_date.split(_delimiter);
    const monthIndex=formatItems.indexOf("mm");
    const dayIndex=formatItems.indexOf("dd");
    const yearIndex=formatItems.indexOf("yyyy");
    const month=parseInt(dateItems[monthIndex]);
    const formatedDate = new Date(parseInt(dateItems[yearIndex]),month-1,parseInt(dateItems[dayIndex]));
    return formatedDate;
  }

  export function stringFrDate(
    _date: Date | string | number,
    _format: string,
    _delimiter?: string
  ) {
    const dateObj =
      _date instanceof Date ? _date : new Date(_date as string | number);
    if (Number.isNaN(dateObj.getTime())) {
      return '';
    }
    const delimiter = _delimiter ?? '.';
    //const formatLowerCase = _format.toLowerCase();
    const formatItems = _format.split(delimiter);
    const year = String(dateObj.getFullYear());
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    const hour = String(dateObj.getHours()).padStart(2, '0');
    const minute = String(dateObj.getMinutes()).padStart(2, '0');
    const second = String(dateObj.getSeconds()).padStart(2, '0');

    const monthIndex = formatItems.indexOf('MM');
    const dayIndex=formatItems.indexOf("dd");
    const yearIndex=formatItems.indexOf("yyyy");
    const hourIndex=formatItems.indexOf("hh");
    const minuteIndex=formatItems.indexOf("mm");
    const secondIndex=formatItems.indexOf("ss");

    const formattedDate = new Array(formatItems.length);
    formattedDate[yearIndex] = year;
    formattedDate[monthIndex] = month;
    formattedDate[dayIndex] = day;
    formattedDate[hourIndex] = hour;
    formattedDate[minuteIndex] = minute;
    formattedDate[secondIndex] = second;
    return formattedDate.join(delimiter);
  }




  export const getDday = (targetDate: Date | string | null | undefined) => {
    if (!targetDate) return '';
    const today = new Date();
    const end =
      targetDate instanceof Date
        ? targetDate
        : new Date(String(targetDate).replace(/\./g, '-'));
    if (Number.isNaN(end.getTime())) {
      return '';
    }
    const diff = Math.ceil((end.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
    return diff > 0 ? `D-${diff}` : 'D-0';
  };



  export function formatTime(sec:number):string {
    //console.log("sec", sec);
    const m = String(Math.floor(sec / 60)).padStart(2, '0');
    const s = String(sec % 60).padStart(2, '0');
    return `${m}:${s}`;
  };


  export function getTimeDiff(startAt: Date, endAt: Date):number {
    console.log("getTimeDiff", startAt, endAt);
    if(!startAt || !endAt || startAt > endAt) {
      console.log("getTimeDiff", 0);
      return 0;
    }
    return Math.floor((endAt.getTime() - startAt.getTime()) / 1000);
  }
  
  